<div class="flex-fill d-flex flex-column justify-content-center align-items-center text-center p-5">
    <div>
        <img class="mb-3" src="assets/images/leaf-active.svg" alt="blank" />
        <p *ngIf="title" class="fnt-14 fnt-general fw-n text-clr588 mb-4">
            {{ title }}
        </p>
        <button *ngIf="button" class="btn-raised" [routerLink]="link">{{ button }}</button>
    </div>
</div>
